export default __webpack_public_path__ + "static/char-s-52-ja-33c75930dcce380b218520c4bfb302ae.png";